import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HormonePatternContent } from '../common/model/dto/hormone-pattern-content';
import { updateHormonePatternContentById } from '../services/admin/admin-hormone-pattern-content.service';

export function useAdminHormonePatternContentMutations(
  hormonePatternContentId: string
) {
  const qc = useQueryClient();
  const invalidateHormonePatternContent = () =>
    qc.invalidateQueries({
      queryKey: ['admin-hormone-pattern-content', hormonePatternContentId],
    });

  const updateHormonePatternContent = useMutation({
    mutationFn: (updates: Partial<HormonePatternContent>) =>
      updateHormonePatternContentById(hormonePatternContentId, updates),
    onSuccess: invalidateHormonePatternContent,
  });

  return {
    updateHormonePatternContent,
  };
}
